<template>
  <div>
    <div v-if="titled"><span>{{ $t('Extras') }}</span></div>
    <div
      v-for="extra in extras"
      :key="extra.name"
      :class="titled ? 'mx-2' : ''"
      class="text-secondary">
      <span>{{ extra.name }}: </span>
      <span class="font-weight-light font-italic">{{ extra.options.map(o => o.value).join(', ') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LineItemExtras',

  props: {
    extras: {
      required: true,
      type: [Object, Array]
    },
    titled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
